<template>
	<Modal :width="850" :title="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.multi.title')"
		   :close-on-click-outside="false"
		   @close="closeNoticeModal">
		<template v-slot:body>
			<div class="modal-content flex flex_column" style="overflow: hidden">
				<div v-if="showMissingSaleParametersHint" class="text_left light_bg_color">
					<span v-html="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.multi.missingParams.hint')"></span>
				</div>
				<div class="margin_top_l text_left">
					<span v-html="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.multi.text')"></span>
				</div>
				<AgItem class="margin_top_l" style="overflow: auto"
						:rowData="rowData"
						:columnDefs="columnDefs"
						height="dynamic"
				/>
			</div>

			<div class="margin_r margin_top flex_end w_100">
				<md-button class="md-blank margin_r" @click="closeNoticeModal">{{ $t("common.button.cancel") }}</md-button>
				<md-button @click="confirm" class="md-primary">{{ $t("common.continue") }}</md-button>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import {enumDef} from "@/common/enumDefs";
import AgItem from "@/components/templates/agGrid/AgItem.vue";
import {asMoneyAmount, asPercentage} from "@/components/templates/agGrid/formatter/valueFormatters";

export default {
	components: {
		AgItem,
		Modal
	},
	props: {
		confirmationData: Array,
	},
	data() {
		return {
			rowData: [],
			columnDefs: []
		};
	},
	created() {
		this.rowData = this.confirmationData.map(data => {
			return {
				invoiceNumber: data.invoiceNumber,
				invoiceAmount: data.amount,
				currency: data.currency,
				discountRate: data.priceCheck.discountRate,
				costOfCapitalRate: this.doesConfirmationUseCostOfCapital(data) ? data.priceCheck.costOfCapitalRate : null,
				priceWithRetention: this.doesConfirmationUseRetention(data) ? data.priceCheck.sellPriceWithRetention : null,
				priceWithoutRetention: data.priceCheck.sellPriceWithoutRetention
			};
		});

		this.columnDefs = [
			{
				headerName: this.$t("common.invoiceNumber"),
				field: "invoiceNumber",
				minWidth: 150
			},
			{
				headerName: this.$t("common.invoiceAmount"),
				headerClass: "align-right",
				field: "invoiceAmount",
				cellStyle: { "justify-content": "flex-end" },
				valueFormatter: asMoneyAmount({ currencyField: "currency" }),
				minWidth: 150
			},
			{
				headerName: this.$t("common.discount"),
				headerClass: "align-right",
				field: "discountRate",
				cellStyle: { "justify-content": "flex-end" },
				valueFormatter: asPercentage(),
				minWidth: 75
			},
			...(this.showCostOfCapitalColumn
				? [{
					headerName: this.$t("common.costOfCapitalPa"),
					headerClass: "align-right",
					field: "costOfCapitalRate",
					cellStyle: { "justify-content": "flex-end" },
					valueFormatter: asPercentage(),
						minWidth: 75
				}] : []
			),
			...(this.showRetentionColumn
				? [{
					headerName: this.$t("seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.sellingPrice.withRetention.header"),
					headerClass: "align-right",
					field: "priceWithRetention",
					cellStyle: { "justify-content": "flex-end" },
					valueFormatter: asMoneyAmount({ currencyField: "currency" }),
					minWidth: 150
				}] : []
			),
			{
				headerName: this.$t("seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.sellingPrice.withoutRetention.header"),
				headerClass: "align-right",
				field: "priceWithoutRetention",
				cellStyle: { "justify-content": "flex-end" },
				valueFormatter: asMoneyAmount({ currencyField: "currency" }),
				minWidth: 150
			}
		];
	},
	computed: {
		enumDef() {
			return enumDef;
		},
		showMissingSaleParametersHint() {
			return this.confirmationData.some(data => !this.doesHaveSaleParameters(data));
		},
		showCostOfCapitalColumn() {
			return this.confirmationData.some(data => this.doesConfirmationUseCostOfCapital(data));
		},
		showRetentionColumn() {
			return this.confirmationData.some(data => this.doesConfirmationUseRetention(data));
		}
	},
	methods: {
		doesHaveSaleParameters(data) {
			return data.priceCheck.calculationType !== enumDef.sellPriceCalculationType.None;
		},
		doesConfirmationUseCostOfCapital(data) {
			return data.priceCheck.calculationType === enumDef.sellPriceCalculationType.CostOfCapital;
		},
		doesConfirmationUseRetention(data) {
			return data.retentionAccepted && data.retentionCheck.isRetentionAllowed;
		},
		closeNoticeModal() {
			this.$emit("close");
		},
		confirm() {
			this.$emit("confirm", this.confirmationData);
		},
	}
};
</script>